export default __webpack_public_path__ + "static/media/Logo-Liva.aaf51520.png";